import { PROBLEMS, PROBLEM_HEADLINE } from '../../data/mock';
import renderEmphasis from '../../lib/renderEmphasis';

export default function Problem() {
  return (
    <section className="py-24 lg:py-36 bg-ivory-warm">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5 reveal">
          <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">{PROBLEM_HEADLINE.eyebrow}</p>
          <h2 className="font-serif text-4xl lg:text-6xl leading-[1.05] text-charcoal">
            {renderEmphasis(PROBLEM_HEADLINE.title)}
          </h2>
          <p className="mt-8 text-charcoal/70 max-w-md leading-relaxed">
            {PROBLEM_HEADLINE.body}
          </p>
          <blockquote className="mt-12 pl-6 border-l-2 border-champagne max-w-md">
            <p className="font-serif text-2xl italic text-charcoal/90 leading-snug">
              &ldquo;Your wardrobe should work as hard as you do.&rdquo;
            </p>
          </blockquote>
        </div>

        <div className="lg:col-span-7 reveal">
          <ul className="divide-y divide-charcoal/10 border-y border-charcoal/10">
            {PROBLEMS.map((p) => (
              <li key={p.n} className="group flex items-center gap-6 py-7 transition-colors hover:bg-ivory cursor-default">
                <span className="font-display text-lg text-champagne-deep w-10 shrink-0">{p.n}</span>
                <span className="font-serif text-xl md:text-2xl text-charcoal flex-1">{p.text}</span>
                <span className="h-px w-6 bg-charcoal/30 group-hover:w-12 group-hover:bg-champagne-deep transition-all duration-500" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
